import { render, staticRenderFns } from "./documentoFData.vue?vue&type=template&id=07a07d96&scoped=true"
import script from "./documentoFData.vue?vue&type=script&lang=js"
export * from "./documentoFData.vue?vue&type=script&lang=js"
import style0 from "./documentoFData.vue?vue&type=style&index=0&id=07a07d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a07d96",
  null
  
)

export default component.exports